// extracted by mini-css-extract-plugin
export default {"container":"LegendScaleSlider_container__RBhhF","inputNumberContainer":"LegendScaleSlider_inputNumberContainer__V3AOq","inputWrapper":"LegendScaleSlider_inputWrapper__ouSpr"};